export default function BrandValueSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6 text-center">
        <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-widest uppercase mb-4">
          Why Choose Us
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8 leading-tight">
          Why OOPBuy Spreadsheet is Changing
          <br />
          the Way People Shop Online
        </h2>
        <p className="text-foreground-600 text-base md:text-lg max-w-3xl mx-auto leading-relaxed mb-12">
          Unlike traditional shopping platforms, OOPBuy Spreadsheet organizes product data into structured tables that make comparison and decision-making faster and more transparent. This innovative approach has transformed how thousands of shoppers discover and evaluate products online.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-12">
          {[
            { icon: "ri-database-2-line", title: "Centralized Product Data", desc: "All product information organized in one structured spreadsheet system" },
            { icon: "ri-speed-up-line", title: "Faster Comparison", desc: "Compare across multiple suppliers simultaneously without switching tabs" },
            { icon: "ri-time-line", title: "Reduced Browsing Time", desc: "Cut manual browsing by up to 70% with smart spreadsheet filtering" },
            { icon: "ri-money-dollar-circle-line", title: "Better Cost Transparency", desc: "See price breakdowns clearly with side-by-side cost analysis" },
            { icon: "ri-user-smile-line", title: "Beginner-Friendly Design", desc: "Intuitive structure that anyone can start using within minutes" },
            { icon: "ri-shield-check-line", title: "Reliable Data Accuracy", desc: "Updated product listings ensure you always see current information" },
          ].map((item, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 md:p-6 text-left">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="py-3 px-4 text-sm font-semibold text-foreground-900">Feature</th>
                <th className="py-3 px-4 text-sm font-semibold text-primary-600 bg-primary-50/50">OOPBuy Spreadsheet</th>
                <th className="py-3 px-4 text-sm font-semibold text-foreground-700">Traditional Shopping</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {[
                { feature: "Product Search Speed", oopbuy: "Fast & Structured", traditional: "Medium" },
                { feature: "Price Comparison", oopbuy: "Side-by-Side Analysis", traditional: "Manual Only" },
                { feature: "Order Tracking", oopbuy: "Spreadsheet-Based", traditional: "Fragmented" },
                { feature: "User Efficiency", oopbuy: "High", traditional: "Low" },
                { feature: "Data Clarity", oopbuy: "Excellent", traditional: "Limited" },
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200/70">
                  <td className="py-3 px-4 font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-3 px-4 text-primary-700 font-medium bg-primary-50/30">{row.oopbuy}</td>
                  <td className="py-3 px-4 text-foreground-600">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}